export default __webpack_public_path__ + "static/media/mastercard.5d72a709.svg";